import { Component, OnInit, Input } from '@angular/core';
import { LocalDataSource } from 'ng2-smart-table';
import { MachinesService } from '../services/machines.service';
import { NbDialogService } from '@nebular/theme';
import Swal, { SweetAlertIcon } from 'sweetalert2';
import { NewMachineComponent } from '../new-machine/new-machine.component';
import { EditMachineComponent } from '../edit-machine/edit-machine.component';
import {environment} from '../../environments/environment';
import {FilesService} from "../services/files.service";

@Component({
  selector: 'ngx-machines',
  templateUrl: './machines.component.html',
  styleUrls: ['./machines.component.scss'],
})
export class MachinesComponent implements OnInit {
  @Input() stationId: string;
  source: LocalDataSource;
  loading: boolean = false;
  token = '';
  settings = {
    actions: {
      position: 'right',
      columnTitle: 'Acciones',
      add: false,
      edit: false,
      delete: false,
      custom: [
        {
          name: 'download',
          title: '<img src="assets/images/icons/download.png" width="25px">',
        },
        {
          name: 'edit',
          title: '<img src="assets/images/icons/edit.png" width="25px">',
        },
        {
          name: 'delete',
          title: '<img src="assets/images/icons/delete.png" width="25px">',
        },
      ],
    },
    pager: {
      perPage: 10,
    },
    columns: {
      name: {
        title: 'Nombre',
        filter: true,
      },
      brand: {
        title: 'Marca',
        filter: true,
      },
      model: {
        title: 'Modelo',
        filter: true,
      },
      location: {
        title: 'Ubicación',
        filter: true,
      },
    },
  };

  downloading = false;

  constructor(
    private machineService: MachinesService,
    private dialogService: NbDialogService,
    private fileService: FilesService,
  ) { }

  async ngOnInit() {
    await this.getEquipment();
  }

  async getEquipment() {
    this.loading = true;
    const [error, { data: result }] = await this.machineService.getEquipment(this.stationId);
    if (error) return error;
    for await (const item of result) {
      item.url = await this.generateUrl(item.id);
    }
    console.error(result);
    this.source = new LocalDataSource(result);
    this.loading = false;
  }

  async generateUrl (id: string) {
    return `${environment.baseEndpoint}/filesGeneratorv2/implementation/eleven/${id}/equipment/${this.stationId}`;
  }

  async downloadFile(url, name) {
    this.downloading = true;
    await this.fileService.downloadFile(url, name);
    this.downloading = false;
  }

  openNewEmployee() {
    this.dialogService.open(NewMachineComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
      },
    }).onClose.subscribe(equipmentStored => equipmentStored ? this.getEquipment() : null);
  }

  onCustom(event: any) {
    if (event.action === 'delete') {
      this.deleteEquipment(event.data.id);
    } else if (event.action === 'edit') {
      this.editEmployee(event.data);
    } else {
      this.downloadFile(event.data.url, event.data.name);
    }
  }

  async editEmployee(equipment) {
    this.dialogService.open(EditMachineComponent, {
      hasScroll: true,
      context: {
        stationId: this.stationId,
        equipment: equipment,
      },
    }).onClose.subscribe(equipmentUpdated => equipmentUpdated ? this.getEquipment() : null);
  }

  async deleteEquipment(id) {
    Swal.fire({
      title: '¿Estás seguro de eliminar?',
      text: 'Esta acción no se puede revertir',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Borrar',
    }).then(async (result) => {
      if (result.value) {
        const [error] = await this.machineService.deleteEquipment(this.stationId, id);
        if (error) return this.alert('Ocurrio un error al intentar borrar el elemento, intenta más tarde por favor', 'error');
        this.alert('Equipo borrado con éxito');
        this.getEquipment();
      }
    });
  }

  alert(title: string = 'asdasd', type: SweetAlertIcon = 'success', text: string = '') {
    Swal.fire({
      icon: type,
      title: title,
      text: text,
    });
  }
}
